import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=0629a4a0"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0629a4a0')) {
      api.createRecord('0629a4a0', component.options)
    } else {
      api.reload('0629a4a0', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=0629a4a0", function () {
      api.rerender('0629a4a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/nieuwsmaker/components/Sidebar.vue"
export default component.exports